import './header.styles.scss';

export default function Header() {
  return (
    <header className="header container">
      <h1 className='header__h1'>Password Generator</h1>
    </header>
  )
}
